/**
 * Перевод строк, которые рисует или создаёт движок (подписи на холсте, значения по умолчанию).
 * Движок не знает о словарях приложения: веб подключает свой переводчик через setEngineTranslator.
 * Вызывать etr() в момент отрисовки/создания, а не при загрузке модуля.
 */
let translate: (text: string) => string = (s) => s;

export function setEngineTranslator(fn: (text: string) => string): void {
  translate = fn;
}

export function etr(text: string): string {
  return translate(text);
}
